<template lang="pug">
    div.search-contract(v-if="currentComponent")
        component(
            :is="currentComponent"
            ref="searchContractComponent"
        )
</template>

<script>
export default {
    name: 'SearchContract',
    data() {
        return {
            components: {
                'PY': () => import('@/modules/traceability-report/views/components/search-contract/content.vue')
            }
        };
    },
    computed: {
        currentComponent() {
            const user = this.$store.state.usuarioLogado;
            return this.components[user.paisGrupo];
        }
    }
};
</script>

<style scoped lang="scss">
</style>
